export const deData = `
  <div class="paragraph">
    <div class="page-title">Häufig gestellte Fragen zum Trade-In-Programm (FAQ)</div>
  </div>
  <div class="paragraph">
    <div class="title">Was sollte ich beim Verkauf eines Mobiltelefons an Danghuan beachten?</div>
    <div class="text-box">
      <div class="text">
        Das Mobiltelefon muss zurückgesetzt sein, wobei alle persönlichen Daten und PINs entfernt wurden. Bei iPhones: Stellen Sie sicher, dass das Gerät von Ihrem iCloud-Konto getrennt ist.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Was passiert, wenn der Zustand meines Telefons anders bewertet wird als von mir angegeben?</div>
    <div class="text-box">
      <div class="text">
        Falls wir eine Abweichung im Gerätezustand feststellen, informieren wir Sie und unterbreiten Ihnen ein neues Angebot basierend auf unserer technischen Bewertung. Stellt unser Team fest, dass das Gerät in einem besseren Zustand ist als von Ihnen angegeben, werden wir Sie ebenfalls benachrichtigen.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Wann wird mein Gerät überprüft?</div>
    <div class="text-box">
      <div class="text">
        Die meisten Sendungen werden mit unserer Prüfsoftware innerhalb weniger Minuten nach Ankunft begutachtet.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Was passiert mit meinen Daten?</div>
    <div class="text-box">
      <div class="text">
        Bitte stellen Sie sicher, dass alle Ihre Daten gelöscht sind, bevor Sie uns Ihr Mobiltelefon zusenden. Verbleiben beim Eingang noch Daten auf dem Gerät, benachrichtigen wir Sie und bitten um Ihre Erlaubnis zur Löschung.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Sollte ich das Zubehör mitschicken?</div>
    <div class="text-box">
      <div class="text">
        Es ist nicht verpflichtend, aber wir empfehlen es, um den Recyclingprozess optimal zu unterstützen. Das Mitschicken von Zubehör trägt zu einem effizienteren Ressourcenmanagement bei und hilft, die Umweltauswirkungen zu verringern.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Sollte ich meine Kopfhörer mitschicken?</div>
    <div class="text-box">
      <div class="text">
        Das ist nicht notwendig. Aus hygienischen Gründen werden Kopfhörer entsorgt und fließen nicht in die Bewertung ein.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Sollte ich die Rechnung für mein Mobiltelefon mitschicken?</div>
    <div class="text-box">
      <div class="text">
        Das ist nicht notwendig. Sie können sie für Ihre Unterlagen behalten, da wir sie für den Bewertungsprozess nicht benötigen.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Was passiert, wenn mein Gerät in einem schlechten Zustand ist?</div>
    <div class="text-box">
      <div class="text">
        Wir bewerten Ihr Gerät anhand eines klaren und fairen Standards und senden Ihnen die Bewertung so schnell wie möglich per E-Mail zu.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Kann ich ein Telefon mit SIM-Lock verkaufen?</div>
    <div class="text-box">
      <div class="text">
        Nein, leider können wir Mobiltelefone mit SIM-Lock nicht ankaufen.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Kauft Danghuan nur Mobiltelefone oder auch andere Geräte?</div>
    <div class="text-box">
      <div class="text">
        Wir kaufen auch andere elektronische Geräte wie Tablets, Smartwatches und Laptops an.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Wie bewerten Sie die Mobiltelefone und anderen Geräte, die in Ihren Amazon-, Back Market- und Wallapop-Shops verkauft werden?</div>
    <div class="text-box">
      <div class="text">
        Wir führen bei all unseren Telefonen und Tablets eine vollständige Diagnose und Sichtprüfung durch. Jedes Gerät wird einzeln getestet und erhält eine Bewertung basierend auf seinem physischen Erscheinungsbild und seiner Funktionalität. Die Bewertungen sind im Folgenden erläutert:
      </div>
      <div class="text">
        <strong>Fabrikneu in Originalverpackung:</strong> Produkt in der Originalverpackung. Keine Gebrauchsspuren und in einwandfreiem funktionalem Zustand.
      </div>
      <div class="text">
        <strong>Generalüberholt in wie-neu-Zustand:</strong> Premium-Produkt in 'wie neu'-Zustand zu einem reduzierten Preis. Keine Gebrauchsspuren und in unserer Verpackung.
      </div>
      <div class="text">
        <strong>Generalüberholt in ausgezeichnetem Zustand:</strong> Produkt in ausgezeichnetem Zustand mit vereinzelten Abnutzungsspuren auf der Vorder-, Rückseite oder den Seiten. Voll funktionsfähig.
      </div>
      <div class="text">
        <strong>Generalüberholt in gutem Zustand:</strong> Produkt in durchschnittlichem Zustand mit Gebrauchsspuren. Zeigt Abnutzung auf der Vorder-, Rückseite oder den Seiten. Voll funktionsfähig.
      </div>
      <div class="text">
        <strong>Generalüberholt in akzeptablem Zustand:</strong> Gebrauchtes Produkt in akzeptablem Zustand mit deutlichen Abnutzungsspuren auf der Vorder-, Rückseite oder den Seiten. Voll funktionsfähig mit einer Batteriekapazität von über 70 %.
      </div>
      <div class="text">
        Alle unsere Produkte wurden von einem Fachmann für elektronische Geräte getestet und auf ihre Qualität hin überprüft, bevor sie versendet werden.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Kann ich meinen Verkauf stornieren?</div>
    <div class="text-box">
      <div class="text">
        Selbstverständlich. Dies ist jedoch nur möglich, bis zu dem Zeitpunkt, an dem wir die Zahlung an Sie veranlassen.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Wie kann ich eine Bestellung stornieren?</div>
    <div class="text-box">
      <div class="text">
        Wenn Sie eine Verkaufsbestätigung per E-Mail erhalten haben, den Verkauf aber stornieren möchten, können Sie eine E-Mail an unser Kundenservice-Team unter <span class="email">order@danghuan.au.com</span> senden. Sie werden Sie bei der Stornierung unterstützen.
      </div>
    </div>
  </div>
`;